import { createSelector } from 'reselect'
import { formIdFromAnswersHubSelector } from './hub'
import { RootState } from '../types/rootstate'

const searchSelector = (state: RootState) => state.search

export const currentSearchStatusSelector = createSelector(
  [ searchSelector, formIdFromAnswersHubSelector ],
  (search, formId) => {
    const item = search[formId]
    return (item && item.status) || 'none'
  }
)

export const currentSearchResultSelector = createSelector(
  [ searchSelector, formIdFromAnswersHubSelector ],
  (search, formId) => {
    const item = search[formId]
    return (item && item.result) || {
      results: [],
      search: '',
      suggest: ''
    }
  }
)

export const currentSearchStringSelector = createSelector(
  [ searchSelector, formIdFromAnswersHubSelector ],
  (search, formId) => {
    const item = search[formId]
    return (item && item.search) || ''
  }
)

export const currentSearchResultIdSelector = createSelector(
  [ searchSelector, formIdFromAnswersHubSelector ],
  (search, formId) => {
    const item = search[formId]
    return (item && item.searchResultId) || -1
  }
)
